import React, { Component, useEffect, useRef, useState } from 'react';
import { Container, Row, Col, FormControl, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { Spinner } from 'react-activity';
import moment from 'moment';

import BackArrow from '../../Images/arrow-left.svg';
import { ReactComponent as Check } from '../../Images/check-correct-blue.svg'

export default function Receipt (props){
  const { services, ecomm, General } = props.traductions



  const renderDate = () => { 
    let date=moment().utc()
    return `${date.format('D')} / ${General.months[date.get('month')+1]} / ${date.get('year')}`
  }

  return(
    <Container className="services_container" style={{ paddingLeft: 10, paddingRight: 10 }}>
      <div>
        <div className='back-button' style={{ cursor:'pointer', marginTop:-15, marginBottom:10, display:'flex', alignItems:'center'}} onClick={()=>props.goBack()}>
          {/* <Image src={BackArrow} style={{ marginTop:-3, marginRight:10}}/> */}
          <p className='dark-text medium-dms text-25' style={{margin:0}}>{services.title}</p>
        </div>
      </div>

      <div className='container-transactions'>

        <div style={{display:'flex',flexDirection:'column', width:'100%', alignItems:'center'}}>
            {/* <Image src={Check} style={{ height:40 }}/> */}
            <Check height={40} fill="#486BF6" color='#486BF6' stroke='#486BF6'/>
            <p className='blue-text medium-dms' style={{marginTop:20}}>{services.receipt.title}</p>
            {
              (props.service && props.service.logo == 'NO LOGO')
              ? props.service.name
              : <Image src={'data:image/svg+xml;base64,'+props.service.logo} style={{ height:50 }} />
            }
        </div>
        <div style={{width:'100%', height:1, backgroundColor:'#D6D6D6', marginTop:'1em', marginBottom:'1em'}}/>

        <div>
            <div className="flex space-between" style={{marginBottom:5}}>
                <div>
                    {services.receipt.cap1}
                </div>
                <div className='gray-text'>
                    {renderDate()}
                </div>
            </div>
            <div className="flex space-between" style={{marginBottom:5}}>
                <div>
                    {services.receipt.cap2}
                </div>
                <div className='gray-text'>
                    {props['service'].name}
                </div>
            </div>
            <div className="flex space-between" style={{marginBottom:5}}>
                <div>
                    {props.label_service}
                </div>
                <div className='gray-text'>
                    {props['reference']}
                </div>
            </div>
            <div className="flex space-between" style={{marginBottom:5}}>
                <div>
                    {services.receipt.cap4}
                </div>
                <div className='gray-text'>
                    {props['valueCrypto']}
                </div>
            </div>
        </div>

        <div>
            <button
              className={'services_continue_button'}
              onClick={()=>{props.goBack()}}
              >
              {services.goBack}
            </button>
          </div>

      </div>
    </Container>
  )
}
